import { useTranslation } from 'react-i18next';
import { useRecognitionsSettings } from 'store/recognitions';
import { useMe } from 'state/Administrators';
import { RecognitionType } from './recognitions.types';

export const usePointsLabel = () => {
  const { t } = useTranslation();
  const { hasViewPermission } = useMe();

  const { data: settings } = useRecognitionsSettings({
    enabled: hasViewPermission(['employeeRecognition']),
  });

  return settings ? t(`recognition.pointNames-${settings.pointName}`) : '';
};

export const getMissingSenderLabelKey = (type: RecognitionType) =>
  type === 'employeeToEmployee'
    ? 'marketplace.employeeDeleted'
    : `recognitions.type.${type}`;
